import { useStore } from "@/composable/useStore"
import { WorkspaceTemplate } from "@/types/workspace"
import { computed } from "@vue/composition-api"

export const getRegion = (space: WorkspaceTemplate) => {
  const { spaceModule } = useStore()

  const regions = computed(() => {
    return spaceModule.spaceRegions
  })

  const regionPrettyName = computed(() => {
    const selectedRegion = regions.value.find(r => r.code === space.cloudZone)

    if (selectedRegion) {
      return {
        name: `${selectedRegion.fullName}`,
        code: selectedRegion.code
      }
    }

    return null
  })

  return regionPrettyName.value
}
